export default __webpack_public_path__ + "static/laravel_service_features-5ae3b19a64848b75f32eb1c5ece42de9.svg";